// extracted by mini-css-extract-plugin
export default {"history":"C+9nJwhS3znLUPG3tjQNFw==","historyHeading":"LWTs4tewOPnTkC+iuTiidA==","historyLoader":"hXnmztdaaU+2mZAxR5ir-w=="};